import React, { useState } from 'react'
import YnsIcon from '~/components/icons/YnsIcon'
import { Button } from '~/lib/ui/button'
import { Calendar } from '~/lib/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '~/lib/ui/popover'

const Filters = ({ table }) => {
  const [date, setDate] = useState()
  const setColumnFilters = table.options.meta?.setColumnFilters

  const handleSelect = (selectedDate) => {
    setDate(selectedDate)
    setColumnFilters([
      {
        id: 'name',
        value: selectedDate,
      },
    ])
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost">
          <YnsIcon name="filter" />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <Calendar mode="single" selected={date} onSelect={handleSelect} />
      </PopoverContent>
    </Popover>
  )
}

export default Filters
